import { DatePickerWebElementBase } from './DatePickerWebElementBase';

/**
 * The component WebElement for [oj-c-date-picker](../../jsdocs/oj-c.DatePicker.html).
 * Do not instantiate this class directly, instead, use
 * [findDatePicker](../functions/findDatePicker.html).
 */
export class DatePickerWebElement extends DatePickerWebElementBase {
  // Put overrides here
}
